// InvoiceContext.js
import { createContext, useContext, useState } from "react";

const InvoiceContext = createContext(null);

export const useInvoice = () => useContext(InvoiceContext);

export const InvoiceProvider = ({ children }) => {
  const [invoiceData, setInvoiceData] = useState({});

  const updateInvoiceData = (data) => {
    setInvoiceData((prev) => ({ ...prev, ...data }));
  };

  return (
    <InvoiceContext.Provider value={{ invoiceData, updateInvoiceData }}>
      {children}
    </InvoiceContext.Provider>
  );
};
